import { createQuery } from "react-query-kit";

import type { IDashboardCardData } from "@components/molecules/dashboardCard";
import { useUserStore } from "@/stores/userStore";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, AxiosError } from "@/api";

const key = "doctor-dashboard";

type IResponse = IApiResponse<IDashboardCardData[]>;
type IVariables = object;

export const getDashboard: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  const { data } = await axiosClient.get(
    `/dashboard/${useUserStore.getState().role}`,
    {
      params,
      signal,
    },
  );

  return data;
};

export const useDashboard = createQuery<IResponse, IVariables, AxiosError>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getDashboard(variables, signal),
  retry(_failureCount, error) {
    return error.code !== AxiosError.ERR_BAD_REQUEST;
  },
  keepPreviousData: true,
});
